module.exports = __webpack_public_path__ + "static/media/tribute.f33378df.png";